<template>
  <div class="page">
    <div class="seiten-kopf">
      <router-link to="/einkaufsliste" class="seiten-kopf-zurueck" aria-label="Zurück">
        <font-awesome-icon icon="fa-solid fa-arrow-left" />
      </router-link>
      <h1>Kategorien</h1>
    </div>

    <router-link to="/einkaufsliste/kategorien/neu" class="btn btn-primary neue-kategorie-button">Neue Kategorie</router-link>

    <p v-if="Kategorien.length === 0" class="hint-message">Noch keine Kategorien vorhanden.</p>

    <div v-else class="eintrag-liste-scroll">
      <draggable
        :list="Kategorien"
        item-key="Id"
        tag="div"
        class="eintrag-liste"
        handle=".ziehgriff"
        @end="SortierungSpeichern"
      >
        <template #item="{ element }">
          <div class="eintrag-zeile">
            <div class="eintrag-kopf">
              <span class="ziehgriff" aria-label="Zum Sortieren ziehen">
                <font-awesome-icon icon="fa-solid fa-grip-lines" />
              </span>
              <span class="eintrag-name kategorie-name">{{ element.Name }}</span>
            </div>
            <div class="eintrag-aktionen">
              <router-link :to="`/einkaufsliste/kategorien/bearbeiten/${element.Id}`" class="aktion-button">Bearbeiten</router-link>
              <button type="button" class="aktion-button loeschen" @click="Loeschen(element)">Löschen</button>
            </div>
          </div>
        </template>
      </draggable>
    </div>

  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { Kategorien, KategorienLaden, KategorieLoeschen, KategorienSortierenSpeichern } from '../composables/useZutaten'

export default {
  name: 'KategorienAnzeigenView',
  components: {
    draggable
  },
  data() {
    return {
      Kategorien
    }
  },
  async created() {
    await KategorienLaden()
  },
  methods: {
    async Loeschen(Kategorie) {
      if (confirm(`Kategorie "${Kategorie.Name}" wirklich löschen?`)) {
        await KategorieLoeschen(Kategorie.Id)
      }
    },
    SortierungSpeichern() {
      KategorienSortierenSpeichern()
    }
  }
}
</script>

<style scoped>
.neue-kategorie-button {
  display: inline-block;
  max-width: 220px;
  margin-top: 16px;
  margin-bottom: 16px;
}

.ziehgriff {
  cursor: grab;
  color: var(--color-text);
  opacity: 0.6;
  padding: 4px 8px;
}

.kategorie-name {
  flex: 1;
}
</style>
